export function setState(state) {
    return { type: "SET_STATE", state }
};

export function setStateObject(objectName, state) {
    return { type: "SET_STATE_OBJECT", objectName, state }
};

